import React, { useState, useEffect } from 'react';
import { CustomMarkerPreview, IconTextInput } from '..';

export function IconMarkerPicker({ value, onChange }) {
  const [searchStr, setSearchStr] = useState('');

  const handleIconChange = (data) => {
    console.log('Picker: ', data);
    if (onChange) onChange(data);
  };

  const handleSearchChange = (ev) => {
    const { value } = ev.currentTarget;
    setSearchStr(value);
  };

  return (
    <div className="chronos-marker-template-icon-picker-component">
      {/* <IconTextInput value={value} onChange={handleIconChange} /> */}
      <div className="icon-display">
        <CustomMarkerPreview />
      </div>
      <div className="chronos-marker-template-icon-search">
        <input
          type="text"
          value={searchStr}
          onChange={handleSearchChange}
          placeholder="Search Icons"
          className="form-control"
        />
        <div className="chronos-marker-template-search-results">Results</div>
      </div>
    </div>
  );
}
